import dayjs from 'dayjs'

export const toYYYYMMDD = (day) => dayjs(day).format('YYYY-MM-DD')
